// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  padding: 20px;
}
.home-container .header-bar {
  padding: 0.5rem 1rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  background-color: #2C7EA0;
}
.home-container .header-bar .header-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #ffffff;
}
.home-container .header-bar .nav-link {
  color: rgba(255, 255, 255, 0.8) !important;
  font-weight: 500;
  padding: 0.5rem 1rem !important;
  margin: 0 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.home-container .header-bar .nav-link:hover {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.1);
}
.home-container .header-bar .nav-link.active {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.2);
  font-weight: 600;
}
.home-container .header-bar .logout-btn {
  font-weight: 500;
  padding: 0.4rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
}
.home-container .header-bar .logout-btn:hover {
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  color: #fff;
}
.home-container .future-functionality {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-container .future-functionality h2 {
  color: #495057;
  margin-bottom: 1rem;
}
.home-container .future-functionality p {
  font-size: 1.1rem;
  color: #6c757d;
}
.home-container .iconsult-container {
  padding: 20px 0;
  width: 100%;
  max-width: none;
  margin: 0;
}
.home-container .iconsult-container h1 {
  color: #2C7EA0;
  margin-bottom: 1rem;
  font-weight: 600;
}
.home-container .iconsult-container p {
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 2rem;
}
.home-container .iconsult-container .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}
.home-container .iconsult-container .card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.25rem;
}
.home-container .iconsult-container .card .card-header h5 {
  margin: 0;
  color: #495057;
  font-weight: 600;
  font-size: 1.1rem;
}
.home-container .iconsult-container .card .card-body {
  padding: 1.5rem;
}
.home-container .iconsult-container .form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}
.home-container .iconsult-container .form-label strong {
  color: #2C7EA0;
}
.home-container .iconsult-container .form-control {
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.9rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.home-container .iconsult-container .form-control:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.home-container .iconsult-container .form-control[readonly] {
  background-color: #f8f9fa;
  color: #6c757d;
}
.home-container .iconsult-container .form-select {
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.9rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.home-container .iconsult-container .form-select:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.home-container .iconsult-container .form-check {
  margin-bottom: 0.5rem;
}
.home-container .iconsult-container .form-check .form-check-input:checked {
  background-color: #2C7EA0;
  border-color: #2C7EA0;
}
.home-container .iconsult-container .form-check .form-check-input:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.home-container .iconsult-container .form-check .form-check-label {
  font-size: 0.9rem;
  color: #495057;
  cursor: pointer;
}
.home-container .iconsult-container .btn {
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
  font-size: 0.9rem;
}
.home-container .iconsult-container .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.home-container .iconsult-container .btn.btn-primary {
  background-color: #2C7EA0;
  border-color: #2C7EA0;
}
.home-container .iconsult-container .btn.btn-primary:hover:not(:disabled) {
  background-color: #1e5a7a;
  border-color: #1e5a7a;
  transform: translateY(-1px);
}
.home-container .iconsult-container .btn.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}
.home-container .iconsult-container .btn.btn-success:hover:not(:disabled) {
  background-color: #218838;
  border-color: #218838;
  transform: translateY(-1px);
}
.home-container .iconsult-container .btn.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}
.home-container .iconsult-container .btn.btn-danger:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
  transform: translateY(-1px);
}
.home-container .iconsult-container .btn.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}
.home-container .iconsult-container .btn.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
  border-color: #5a6268;
  transform: translateY(-1px);
}
.home-container .iconsult-container .alert {
  border-radius: 6px;
  border: none;
  padding: 1rem 1.25rem;
}
.home-container .iconsult-container .alert.alert-success {
  background-color: #d4edda;
  color: #155724;
}
.home-container .iconsult-container .alert.alert-error {
  background-color: #f8d7da;
  color: #721c24;
}
.home-container .iconsult-container .alert.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
}
.home-container .iconsult-container .d-grid {
  gap: 0.75rem;
}
.home-container .iconsult-container .d-md-flex {
  gap: 0.75rem;
}
@media (max-width: 768px) {
  .home-container .iconsult-container {
    padding: 15px;
  }
  .home-container .iconsult-container .card-body {
    padding: 1rem;
  }
  .home-container .iconsult-container .btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
  }
  .home-container .iconsult-container .form-control,
  .home-container .iconsult-container .form-select {
    padding: 0.6rem;
    font-size: 0.85rem;
  }
}
.home-container .iconsult-container .loading {
  opacity: 0.7;
  pointer-events: none;
}
.home-container .iconsult-container .generated-link {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.8rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.5rem;
  word-break: break-all;
}
.home-container .iconsult-container .status-message {
  font-weight: 500;
  margin-bottom: 0;
}
.home-container .iconsult-container h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}
.home-container .iconsult-container .main-content-flex {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.home-container .iconsult-container .sidebar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  transition: all 0.3s ease;
}
.home-container .iconsult-container .sidebar.left {
  width: 260px;
  min-width: 260px;
  max-height: 80vh;
  overflow-y: auto;
}
.home-container .iconsult-container .sidebar.left.closed {
  width: 50px;
  min-width: 50px;
  padding: 10px;
}
.home-container .iconsult-container .sidebar .toggle-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  padding: 4px 8px;
  font-size: 12px;
}
.home-container .iconsult-container .sidebar h4 {
  color: #2C7EA0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
}
.home-container .iconsult-container .sidebar h4:first-child {
  margin-top: 0;
}
.home-container .iconsult-container .sidebar .form-group {
  margin-bottom: 1rem;
}
.home-container .iconsult-container .sidebar .form-label {
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
}
.home-container .iconsult-container .sidebar .form-label strong {
  color: #2C7EA0;
}
.home-container .iconsult-container .sidebar .form-control,
.home-container .iconsult-container .sidebar .form-select {
  font-size: 0.85rem;
  padding: 0.5rem;
  border-radius: 4px;
}
.home-container .iconsult-container .sidebar .form-check {
  margin-bottom: 0.5rem;
}
.home-container .iconsult-container .sidebar .form-check .form-check-label {
  font-size: 0.85rem;
  color: #495057;
}
.home-container .iconsult-container .sidebar .btn {
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
}
.home-container .iconsult-container .center-content {
  flex: 1;
  min-width: 0;
  width: 100%;
}
.home-container .iconsult-container .center-content h4 {
  color: #2C7EA0;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}
.home-container .iconsult-container .center-content .card {
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  .home-container .iconsult-container .main-content-flex {
    flex-direction: column;
    gap: 15px;
  }
  .home-container .iconsult-container .sidebar.left {
    width: 100%;
    min-width: auto;
    max-height: none;
  }
  .home-container .iconsult-container .sidebar.left.closed {
    width: 100%;
    min-width: auto;
  }
  .home-container .iconsult-container .center-content {
    width: 100%;
  }
}
.home-container .p2p-container {
  padding: 20px 0;
  width: 100%;
  max-width: none;
  margin: 0;
}
.home-container .p2p-container h1 {
  color: #2C7EA0;
  margin-bottom: 1rem;
  font-weight: 600;
}
.home-container .p2p-container p {
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 2rem;
}
.home-container .p2p-container .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}
.home-container .p2p-container .card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.25rem;
}
.home-container .p2p-container .card .card-header h5 {
  margin: 0;
  color: #495057;
  font-weight: 600;
  font-size: 1.1rem;
}
.home-container .p2p-container .card .card-body {
  padding: 1.5rem;
}
.home-container .p2p-container .form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}
.home-container .p2p-container .form-label strong {
  color: #2C7EA0;
}
.home-container .p2p-container .form-control {
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.9rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.home-container .p2p-container .form-control:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.home-container .p2p-container .form-control[readonly] {
  background-color: #f8f9fa;
  color: #6c757d;
}
.home-container .p2p-container .form-select {
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.9rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.home-container .p2p-container .form-select:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.home-container .p2p-container .form-check {
  margin-bottom: 0.5rem;
}
.home-container .p2p-container .form-check .form-check-input:checked {
  background-color: #2C7EA0;
  border-color: #2C7EA0;
}
.home-container .p2p-container .form-check .form-check-input:focus {
  border-color: #2C7EA0;
  box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);
}
.home-container .p2p-container .form-check .form-check-label {
  font-size: 0.9rem;
  color: #495057;
  cursor: pointer;
}
.home-container .p2p-container .btn {
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
  font-size: 0.9rem;
}
.home-container .p2p-container .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.home-container .p2p-container .btn.btn-primary {
  background-color: #2C7EA0;
  border-color: #2C7EA0;
}
.home-container .p2p-container .btn.btn-primary:hover:not(:disabled) {
  background-color: #1e5a7a;
  border-color: #1e5a7a;
  transform: translateY(-1px);
}
.home-container .p2p-container .btn.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}
.home-container .p2p-container .btn.btn-success:hover:not(:disabled) {
  background-color: #218838;
  border-color: #218838;
  transform: translateY(-1px);
}
.home-container .p2p-container .btn.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}
.home-container .p2p-container .btn.btn-danger:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
  transform: translateY(-1px);
}
.home-container .p2p-container .btn.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}
.home-container .p2p-container .btn.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
  border-color: #5a6268;
  transform: translateY(-1px);
}
.home-container .p2p-container .btn.btn-info {
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.home-container .p2p-container .btn.btn-info:hover:not(:disabled) {
  background-color: #138496;
  border-color: #138496;
  transform: translateY(-1px);
}
.home-container .p2p-container .alert {
  border-radius: 6px;
  border: none;
  padding: 1rem 1.25rem;
}
.home-container .p2p-container .alert.alert-success {
  background-color: #d4edda;
  color: #155724;
}
.home-container .p2p-container .alert.alert-error {
  background-color: #f8d7da;
  color: #721c24;
}
.home-container .p2p-container .alert.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
}
.home-container .p2p-container .d-grid {
  gap: 0.75rem;
}
.home-container .p2p-container .d-md-flex {
  gap: 0.75rem;
}
.home-container .p2p-container .table {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.home-container .p2p-container .table thead {
  background-color: #f8f9fa;
}
.home-container .p2p-container .table thead th {
  border-bottom: 2px solid #dee2e6;
  color: #495057;
  font-weight: 600;
  padding: 1rem 0.75rem;
  font-size: 0.9rem;
}
.home-container .p2p-container .table tbody tr:hover {
  background-color: #f8f9fa;
}
.home-container .p2p-container .table tbody tr td {
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  font-size: 0.9rem;
  vertical-align: middle;
}
@media (max-width: 768px) {
  .home-container .p2p-container {
    padding: 15px;
  }
  .home-container .p2p-container .card-body {
    padding: 1rem;
  }
  .home-container .p2p-container .btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
  }
  .home-container .p2p-container .form-control,
  .home-container .p2p-container .form-select {
    padding: 0.6rem;
    font-size: 0.85rem;
  }
  .home-container .p2p-container .table {
    font-size: 0.8rem;
  }
  .home-container .p2p-container .table th, .home-container .p2p-container .table td {
    padding: 0.5rem 0.25rem;
  }
}
.home-container .p2p-container .loading {
  opacity: 0.7;
  pointer-events: none;
}
.home-container .p2p-container .generated-link {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.8rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.5rem;
  word-break: break-all;
}
.home-container .p2p-container .status-message {
  font-weight: 500;
  margin-bottom: 0;
}
.home-container .p2p-container h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}
.home-container .p2p-container .main-content-flex {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.home-container .p2p-container .sidebar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  transition: all 0.3s ease;
}
.home-container .p2p-container .sidebar.left {
  width: 260px;
  min-width: 260px;
  max-height: 80vh;
  overflow-y: auto;
}
.home-container .p2p-container .sidebar.left.closed {
  width: 50px;
  min-width: 50px;
  padding: 10px;
}
.home-container .p2p-container .sidebar .toggle-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  padding: 4px 8px;
  font-size: 12px;
}
.home-container .p2p-container .sidebar h4 {
  color: #2C7EA0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
}
.home-container .p2p-container .sidebar h4:first-child {
  margin-top: 0;
}
.home-container .p2p-container .sidebar .form-group {
  margin-bottom: 1rem;
}
.home-container .p2p-container .sidebar .form-label {
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
}
.home-container .p2p-container .sidebar .form-label strong {
  color: #2C7EA0;
}
.home-container .p2p-container .sidebar .form-control,
.home-container .p2p-container .sidebar .form-select {
  font-size: 0.85rem;
  padding: 0.5rem;
  border-radius: 4px;
}
.home-container .p2p-container .sidebar .form-check {
  margin-bottom: 0.5rem;
}
.home-container .p2p-container .sidebar .form-check .form-check-label {
  font-size: 0.85rem;
  color: #495057;
}
.home-container .p2p-container .sidebar .btn {
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
}
.home-container .p2p-container .center-content {
  flex: 1;
  min-width: 0;
  width: 100%;
}
.home-container .p2p-container .center-content h4 {
  color: #2C7EA0;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}
.home-container .p2p-container .center-content .card {
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  .home-container .p2p-container .main-content-flex {
    flex-direction: column;
    gap: 15px;
  }
  .home-container .p2p-container .sidebar.left {
    width: 100%;
    min-width: auto;
    max-height: none;
  }
  .home-container .p2p-container .sidebar.left.closed {
    width: 100%;
    min-width: auto;
  }
  .home-container .p2p-container .center-content {
    width: 100%;
  }
}
.home-container .header-row {
  margin-bottom: 20px;
}
.home-container .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.home-container .main-content-flex {
  margin-top: 2em;
  padding: 1em;
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.home-container .sidebar {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-width: 200px;
  max-width: 300px;
}
.home-container .sidebar.left.closed {
  padding: 10px;
  min-width: 60px;
  max-width: 60px;
}
.home-container .sidebar.left.closed h4, .home-container .sidebar.left.closed .form-group {
  display: none;
}
.home-container .sidebar.right {
  flex: 1;
  min-width: 250px;
  max-width: 400px;
}
.home-container .sidebar .toggle-btn {
  position: relative;
  top: 10px;
  right: -15px;
  z-index: 10;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 14px;
  padding: 0;
}
.home-container .sidebar .token-generation-section {
  border-top: 1px solid #dee2e6;
  padding-top: 15px;
}
.home-container .sidebar .token-generation-section h5 {
  font-size: 14px;
  margin-bottom: 10px;
  color: #495057;
}
.home-container .sidebar .token-generation-section .btn {
  font-size: 12px;
  padding: 6px 12px;
}
.home-container .sidebar .token-generation-section .token-info {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 10px;
}
.home-container .sidebar .token-generation-section .token-info .token-status {
  margin-bottom: 8px;
}
.home-container .sidebar .token-generation-section .token-info .token-expiration .expiration-status {
  font-weight: 500;
}
.home-container .sidebar .token-generation-section .token-info .token-expiration .expiration-status.text-danger {
  color: #dc3545 !important;
}
.home-container .sidebar .token-generation-section .token-info .token-expiration .expiration-status.text-info {
  color: #0dcaf0 !important;
}
.home-container .sidebar .token-generation-section .token-info .token-expiration .time-remaining {
  font-size: 11px;
}
.home-container .center-content {
  flex: 2;
  min-width: 0;
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.home-container .center-content .form-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.home-container .center-content .selected-info-table h5 {
  margin-bottom: 15px;
}
.home-container .center-content .selected-info-table .json-viewer .json-content {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 11px;
  line-height: 1.4;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  color: #495057;
  white-space: pre-wrap;
  word-break: break-word;
}
.home-container .center-content .selected-info-table .json-viewer .btn-outline-secondary {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
}
.home-container .center-content .selected-info-table .json-viewer .btn-outline-secondary:hover {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}
.home-container .center-content .selected-info-table .table-wrapper {
  overflow-x: auto;
  max-width: 100%;
}
.home-container .center-content .selected-info-table .config-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.home-container .center-content .selected-info-table .config-table th, .home-container .center-content .selected-info-table .config-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home-container .center-content .selected-info-table .config-table th {
  background-color: #f1f1f1;
  font-weight: 500;
}
.home-container .center-content .selected-info-table .config-table input[type=checkbox] {
  transform: scale(1.2);
  cursor: pointer;
}
.home-container .center-content .selected-info-table .config-table .text-warning {
  color: #856404;
  font-weight: bold;
}
.home-container h4 {
  margin-top: 1em;
  margin-bottom: 15px;
  font-weight: 600;
}
.home-container form .form-select {
  margin-bottom: 10px;
}
.home-container form .form-text {
  font-size: 0.9rem;
  color: #6c757d;
}`, "",{"version":3,"sources":["webpack://./frontend/sass/pages/home.scss","webpack://./frontend/sass/pages/iconsult.scss","webpack://./frontend/sass/pages/p2p.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEE;EACA,oBAAA;EACA,yCAAA;EACC,yBAAA;AAAH;AAEE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,0CAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AADJ;AAGI;EACE,yBAAA;EACA,0CAAA;AADN;AAII;EACE,yBAAA;EACA,0CAAA;EACA,gBAAA;AAFN;AAME;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gCAAA;AAJJ;AAMI;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AAJN;AASA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;AASE;EACE,cAAA;EACA,mBAAA;AAPJ;AAUE;EACE,iBAAA;EACA,cAAA;AARJ;ACvDA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;ADyDF;ACvDE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;ADyDJ;ACtDE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;ADwDJ;ACrDE;EACE,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qBAAA;ADuDJ;ACrDI;EACE,yBAAA;EACA,gCAAA;EACA,qBAAA;ADuDN;ACrDM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;ADuDR;ACnDI;EACE,eAAA;ADqDN;ACjDE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;ADmDJ;ACjDI;EACE,cAAA;ADmDN;AC/CE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wEAAA;ADiDJ;AC/CI;EACE,qBAAA;EACA,iDAAA;ADiDN;AC9CI;EACE,yBAAA;EACA,cAAA;ADgDN;AC5CE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wEAAA;AD8CJ;AC5CI;EACE,qBAAA;EACA,iDAAA;AD8CN;AC1CE;EACE,qBAAA;AD4CJ;ACzCM;EACE,yBAAA;EACA,qBAAA;AD2CR;ACxCM;EACE,qBAAA;EACA,iDAAA;AD0CR;ACtCI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;ADwCN;ACpCE;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;ADsCJ;ACpCI;EACE,YAAA;EACA,mBAAA;ADsCN;ACnCI;EACE,yBAAA;EACA,qBAAA;ADqCN;ACnCM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;ADqCR;ACjCI;EACE,yBAAA;EACA,qBAAA;ADmCN;ACjCM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;ADmCR;AC/BI;EACE,yBAAA;EACA,qBAAA;ADiCN;AC/BM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;ADiCR;AC7BI;EACE,yBAAA;EACA,qBAAA;AD+BN;AC7BM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AD+BR;AC1BE;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;AD4BJ;AC1BI;EACE,yBAAA;EACA,cAAA;AD4BN;ACzBI;EACE,yBAAA;EACA,cAAA;AD2BN;ACxBI;EACE,yBAAA;EACA,cAAA;AD0BN;ACtBE;EACE,YAAA;ADwBJ;ACrBE;EACE,YAAA;ADuBJ;ACnBE;EAhMF;IAiMI,aAAA;EDsBF;ECpBE;IACE,aAAA;EDsBJ;ECnBE;IACE,sBAAA;IACA,kBAAA;EDqBJ;EClBE;;IAEE,eAAA;IACA,kBAAA;EDoBJ;AACF;AChBE;EACE,YAAA;EACA,oBAAA;ADkBJ;ACdE;EACE,wDAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;ADgBJ;ACZE;EACE,gBAAA;EACA,gBAAA;ADcJ;ACVE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;ADYJ;ACRE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;ADUJ;ACPE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;ADSJ;ACPI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;ADSN;ACPM;EACE,WAAA;EACA,eAAA;EACA,aAAA;ADSR;ACLI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ADON;ACJI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;ADMN;ACJM;EACE,aAAA;ADMR;ACFI;EACE,mBAAA;ADIN;ACDI;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;ADGN;ACDM;EACE,cAAA;ADGR;ACCI;;EAEE,kBAAA;EACA,eAAA;EACA,kBAAA;ADCN;ACEI;EACE,qBAAA;ADAN;ACEM;EACE,kBAAA;EACA,cAAA;ADAR;ACII;EACE,kBAAA;EACA,oBAAA;ADFN;ACME;EACE,OAAA;EACA,YAAA;EACA,WAAA;ADJJ;ACMI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;ADJN;ACOI;EACE,qBAAA;ADLN;ACUE;EACE;IACE,sBAAA;IACA,SAAA;EDRJ;ECWE;IACE,WAAA;IACA,eAAA;IACA,gBAAA;EDTJ;ECWI;IACE,WAAA;IACA,eAAA;EDTN;ECaE;IACE,WAAA;EDXJ;AACF;AEtWA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AFwWF;AEtWE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AFwWJ;AErWE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AFuWJ;AEpWE;EACE,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qBAAA;AFsWJ;AEpWI;EACE,yBAAA;EACA,gCAAA;EACA,qBAAA;AFsWN;AEpWM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AFsWR;AElWI;EACE,eAAA;AFoWN;AEhWE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AFkWJ;AEhWI;EACE,cAAA;AFkWN;AE9VE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wEAAA;AFgWJ;AE9VI;EACE,qBAAA;EACA,iDAAA;AFgWN;AE7VI;EACE,yBAAA;EACA,cAAA;AF+VN;AE3VE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wEAAA;AF6VJ;AE3VI;EACE,qBAAA;EACA,iDAAA;AF6VN;AEzVE;EACE,qBAAA;AF2VJ;AExVM;EACE,yBAAA;EACA,qBAAA;AF0VR;AEvVM;EACE,qBAAA;EACA,iDAAA;AFyVR;AErVI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AFuVN;AEnVE;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;AFqVJ;AEnVI;EACE,YAAA;EACA,mBAAA;AFqVN;AElVI;EACE,yBAAA;EACA,qBAAA;AFoVN;AElVM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AFoVR;AEhVI;EACE,yBAAA;EACA,qBAAA;AFkVN;AEhVM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AFkVR;AE9UI;EACE,yBAAA;EACA,qBAAA;AFgVN;AE9UM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AFgVR;AE5UI;EACE,yBAAA;EACA,qBAAA;AF8UN;AE5UM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AF8UR;AE1UI;EACE,yBAAA;EACA,qBAAA;AF4UN;AE1UM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AF4UR;AEvUE;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;AFyUJ;AEvUI;EACE,yBAAA;EACA,cAAA;AFyUN;AEtUI;EACE,yBAAA;EACA,cAAA;AFwUN;AErUI;EACE,yBAAA;EACA,cAAA;AFuUN;AEnUE;EACE,YAAA;AFqUJ;AElUE;EACE,YAAA;AFoUJ;AEhUE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AFkUJ;AEhUI;EACE,yBAAA;AFkUN;AEhUM;EACE,gCAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AFkUR;AE5TQ;EACE,yBAAA;AF8TV;AE3TQ;EACE,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,sBAAA;AF6TV;AEtTE;EA9OF;IA+OI,aAAA;EFyTF;EEvTE;IACE,aAAA;EFyTJ;EEtTE;IACE,sBAAA;IACA,kBAAA;EFwTJ;EErTE;;IAEE,eAAA;IACA,kBAAA;EFuTJ;EEpTE;IACE,iBAAA;EFsTJ;EEpTI;IACE,uBAAA;EFsTN;AACF;AEjTE;EACE,YAAA;EACA,oBAAA;AFmTJ;AE/SE;EACE,wDAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AFiTJ;AE7SE;EACE,gBAAA;EACA,gBAAA;AF+SJ;AE3SE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;AF6SJ;AEzSE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AF2SJ;AExSE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AF0SJ;AExSI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AF0SN;AExSM;EACE,WAAA;EACA,eAAA;EACA,aAAA;AF0SR;AEtSI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AFwSN;AErSI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AFuSN;AErSM;EACE,aAAA;AFuSR;AEnSI;EACE,mBAAA;AFqSN;AElSI;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AFoSN;AElSM;EACE,cAAA;AFoSR;AEhSI;;EAEE,kBAAA;EACA,eAAA;EACA,kBAAA;AFkSN;AE/RI;EACE,qBAAA;AFiSN;AE/RM;EACE,kBAAA;EACA,cAAA;AFiSR;AE7RI;EACE,kBAAA;EACA,oBAAA;AF+RN;AE3RE;EACE,OAAA;EACA,YAAA;EACA,WAAA;AF6RJ;AE3RI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AF6RN;AE1RI;EACE,qBAAA;AF4RN;AEvRE;EACE;IACE,sBAAA;IACA,SAAA;EFyRJ;EEtRE;IACE,WAAA;IACA,eAAA;IACA,gBAAA;EFwRJ;EEtRI;IACE,WAAA;IACA,eAAA;EFwRN;EEpRE;IACE,WAAA;EFsRJ;AACF;AApnBE;EACE,mBAAA;AAsnBJ;AAnnBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAqnBJ;AAlnBC;EACK,eAAA;EACA,YAAA;EACJ,aAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AAonBF;AAjnBA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAmnBF;AAjnBE;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAmnBJ;AAjnBI;EACE,aAAA;AAmnBN;AA/mBE;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;AAinBJ;AA9mBQ;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAgnBR;AA7mBM;EACE,6BAAA;EACA,iBAAA;AA+mBR;AA7mBQ;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AA+mBV;AA5mBQ;EACE,eAAA;EACA,iBAAA;AA8mBV;AA3mBQ;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AA6mBV;AA3mBU;EACE,kBAAA;AA6mBZ;AAzmBY;EACE,gBAAA;AA2mBd;AAzmBc;EACE,yBAAA;AA2mBhB;AAxmBc;EACE,yBAAA;AA0mBhB;AAtmBY;EACE,eAAA;AAwmBd;AAjmBA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;AAmmBF;AAlmBA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAomBJ;AAhmBI;EACE,mBAAA;AAkmBN;AA9lBM;EACE,wDAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;AAgmBR;AA7lBM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA+lBR;AA7lBQ;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AA+lBV;AA1lBI;EACE,gBAAA;EACA,eAAA;AA4lBN;AAzlBG;EACD,WAAA;EACA,yBAAA;EACA,mBAAA;AA2lBF;AAzlBE;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA2lBJ;AAxlBE;EACE,yBAAA;EACA,gBAAA;AA0lBJ;AAvlBE;EACE,qBAAA;EACA,eAAA;AAylBJ;AAtlBE;EACE,cAAA;EACA,iBAAA;AAwlBJ;AArkBE;EACM,eAAA;EACJ,mBAAA;EACA,gBAAA;AAukBJ;AAnkBI;EACE,mBAAA;AAqkBN;AAlkBI;EACE,iBAAA;EACA,cAAA;AAokBN","sourcesContent":[".home-container {\n  padding: 20px;\n\n\n  .header-bar {\n  padding: 0.5rem 1rem;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n   background-color: #2C7EA0 ; // Blue background\n\n  .header-title {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #ffffff; // White text color\n  }\n\n  .nav-link {\n    color: rgba(255, 255, 255, 0.8) !important;\n    font-weight: 500;\n    padding: 0.5rem 1rem !important;\n    margin: 0 0.25rem;\n    border-radius: 4px;\n    transition: all 0.2s ease-in-out;\n    cursor: pointer;\n\n    &:hover {\n      color: #ffffff !important;\n      background-color: rgba(255, 255, 255, 0.1);\n    }\n\n    &.active {\n      color: #ffffff !important;\n      background-color: rgba(255, 255, 255, 0.2);\n      font-weight: 600;\n    }\n  }\n\n  .logout-btn {\n    font-weight: 500;\n    padding: 0.4rem 1rem;\n    border-radius: 6px;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      background-color: #ff4d4f;\n      border-color: #ff4d4f;\n      color: #fff;\n    }\n  }\n}\n\n.future-functionality {\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  h2 {\n    color: #495057;\n    margin-bottom: 1rem;\n  }\n  \n  p {\n    font-size: 1.1rem;\n    color: #6c757d;\n  }\n}\n\n// Import iConsult styles\n@import 'iconsult';\n\n// Import P2P styles\n@import 'p2p';\n\n  .header-row {\n    margin-bottom: 20px;\n  }\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n .main-content-flex {\n      margin-top: 2em;\n      padding: 1em;\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n}\n\n.sidebar {\n  background-color: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  min-width: 200px;\n  max-width: 300px;\n\n  &.left.closed {\n    padding: 10px;\n    min-width: 60px;\n    max-width: 60px;\n\n    h4, .form-group {\n      display: none;\n    }\n  }\n\n  &.right {\n    flex: 1; // Automatically takes remaining space\n    min-width: 250px;\n    max-width: 400px;\n  }\n\n        .toggle-btn {\n        position: relative;\n        top: 10px;\n        right: -15px;\n        z-index: 10;\n        border-radius: 50%;\n        width: 30px;\n        height: 30px;\n        font-size: 14px;\n        padding: 0;\n      }\n\n      .token-generation-section {\n        border-top: 1px solid #dee2e6;\n        padding-top: 15px;\n        \n        h5 {\n          font-size: 14px;\n          margin-bottom: 10px;\n          color: #495057;\n        }\n        \n        .btn {\n          font-size: 12px;\n          padding: 6px 12px;\n        }\n        \n        .token-info {\n          background-color: #f8f9fa;\n          border: 1px solid #dee2e6;\n          border-radius: 6px;\n          padding: 10px;\n          \n          .token-status {\n            margin-bottom: 8px;\n          }\n          \n          .token-expiration {\n            .expiration-status {\n              font-weight: 500;\n              \n              &.text-danger {\n                color: #dc3545 !important;\n              }\n              \n              &.text-info {\n                color: #0dcaf0 !important;\n              }\n            }\n            \n            .time-remaining {\n              font-size: 11px;\n            }\n          }\n        }\n      }\n    }\n\n.center-content {\n  flex: 2;\n  min-width: 0; // Important for flexbox to prevent overflow\n  padding: 20px;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n.form-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap; // allows wrapping on smaller screens\n  }\n\n  .selected-info-table {\n    h5 {\n      margin-bottom: 15px;\n    }\n\n    .json-viewer {\n      .json-content {\n        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n        font-size: 11px;\n        line-height: 1.4;\n        border: 1px solid #dee2e6;\n        background-color: #f8f9fa;\n        color: #495057;\n        white-space: pre-wrap;\n        word-break: break-word;\n      }\n\n      .btn-outline-secondary {\n        font-size: 11px;\n        padding: 2px 8px;\n        border-radius: 4px;\n        \n        &:hover {\n          background-color: #6c757d;\n          border-color: #6c757d;\n          color: white;\n        }\n      }\n    }\n\n    .table-wrapper {\n      overflow-x: auto;\n      max-width: 100%;\n    }\n\n   .config-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed; // Enforces fixed column widths\n\n  th, td {\n    padding: 12px 16px;\n    text-align: left;\n    border-bottom: 1px solid #e0e0e0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  th {\n    background-color: #f1f1f1;\n    font-weight: 500;\n  }\n\n  input[type=\"checkbox\"] {\n    transform: scale(1.2);\n    cursor: pointer;\n  }\n\n  .text-warning {\n    color: #856404;\n    font-weight: bold;\n  }\n}\n  }\n}\n\n//   .center-content {\n//     background-color: #ffffff;\n//     padding: 20px;\n//     border-radius: 8px;\n//     box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n\n//     .selected-info {\n//       background-color: #f1f3f5;\n//       padding: 15px;\n//       border-radius: 6px;\n//     }\n//   }\n\n  h4 {\n        margin-top: 1em;\n    margin-bottom: 15px;\n    font-weight: 600;\n  }\n\n  form {\n    .form-select {\n      margin-bottom: 10px;\n    }\n\n    .form-text {\n      font-size: 0.9rem;\n      color: #6c757d;\n    }\n  }\n}",".iconsult-container {\n  padding: 20px 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n\n  h1 {\n    color: #2C7EA0;\n    margin-bottom: 1rem;\n    font-weight: 600;\n  }\n\n  p {\n    color: #6c757d;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n  }\n\n  .card {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    margin-bottom: 1.5rem;\n\n    .card-header {\n      background-color: #f8f9fa;\n      border-bottom: 1px solid #dee2e6;\n      padding: 1rem 1.25rem;\n\n      h5 {\n        margin: 0;\n        color: #495057;\n        font-weight: 600;\n        font-size: 1.1rem;\n      }\n    }\n\n    .card-body {\n      padding: 1.5rem;\n    }\n  }\n\n  .form-label {\n    font-weight: 500;\n    color: #495057;\n    margin-bottom: 0.5rem;\n\n    strong {\n      color: #2C7EA0;\n    }\n  }\n\n  .form-control {\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:focus {\n      border-color: #2C7EA0;\n      box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n    }\n\n    &[readonly] {\n      background-color: #f8f9fa;\n      color: #6c757d;\n    }\n  }\n\n  .form-select {\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:focus {\n      border-color: #2C7EA0;\n      box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n    }\n  }\n\n  .form-check {\n    margin-bottom: 0.5rem;\n\n    .form-check-input {\n      &:checked {\n        background-color: #2C7EA0;\n        border-color: #2C7EA0;\n      }\n\n      &:focus {\n        border-color: #2C7EA0;\n        box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n      }\n    }\n\n    .form-check-label {\n      font-size: 0.9rem;\n      color: #495057;\n      cursor: pointer;\n    }\n  }\n\n  .btn {\n    font-weight: 500;\n    padding: 0.75rem 1.5rem;\n    border-radius: 6px;\n    transition: all 0.2s ease-in-out;\n    font-size: 0.9rem;\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    &.btn-primary {\n      background-color: #2C7EA0;\n      border-color: #2C7EA0;\n\n      &:hover:not(:disabled) {\n        background-color: #1e5a7a;\n        border-color: #1e5a7a;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-success {\n      background-color: #28a745;\n      border-color: #28a745;\n\n      &:hover:not(:disabled) {\n        background-color: #218838;\n        border-color: #218838;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-danger {\n      background-color: #dc3545;\n      border-color: #dc3545;\n\n      &:hover:not(:disabled) {\n        background-color: #c82333;\n        border-color: #c82333;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-secondary {\n      background-color: #6c757d;\n      border-color: #6c757d;\n\n      &:hover:not(:disabled) {\n        background-color: #5a6268;\n        border-color: #5a6268;\n        transform: translateY(-1px);\n      }\n    }\n  }\n\n  .alert {\n    border-radius: 6px;\n    border: none;\n    padding: 1rem 1.25rem;\n\n    &.alert-success {\n      background-color: #d4edda;\n      color: #155724;\n    }\n\n    &.alert-error {\n      background-color: #f8d7da;\n      color: #721c24;\n    }\n\n    &.alert-info {\n      background-color: #d1ecf1;\n      color: #0c5460;\n    }\n  }\n\n  .d-grid {\n    gap: 0.75rem;\n  }\n\n  .d-md-flex {\n    gap: 0.75rem;\n  }\n\n  // Responsive adjustments\n  @media (max-width: 768px) {\n    padding: 15px;\n\n    .card-body {\n      padding: 1rem;\n    }\n\n    .btn {\n      padding: 0.6rem 1.2rem;\n      font-size: 0.85rem;\n    }\n\n    .form-control,\n    .form-select {\n      padding: 0.6rem;\n      font-size: 0.85rem;\n    }\n  }\n\n  // Loading states\n  .loading {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n\n  // Generated link styling\n  .generated-link {\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n    font-size: 0.8rem;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    padding: 0.5rem;\n    word-break: break-all;\n  }\n\n  // Status message styling\n  .status-message {\n    font-weight: 500;\n    margin-bottom: 0;\n  }\n\n  // Section headers\n  h6 {\n    color: #495057;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 2px solid #e9ecef;\n  }\n\n  // Sidebar styles (similar to ServiceDropdowns)\n  .main-content-flex {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n    width: 100%;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n  }\n\n  .sidebar {\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 20px;\n    position: relative;\n    transition: all 0.3s ease;\n\n    &.left {\n      width: 260px;\n      min-width: 260px;\n      max-height: 80vh;\n      overflow-y: auto;\n\n      &.closed {\n        width: 50px;\n        min-width: 50px;\n        padding: 10px;\n      }\n    }\n\n    .toggle-btn {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      z-index: 10;\n      padding: 4px 8px;\n      font-size: 12px;\n    }\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.1rem;\n      font-weight: 600;\n      margin-bottom: 1rem;\n      margin-top: 1.5rem;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n\n    .form-group {\n      margin-bottom: 1rem;\n    }\n\n    .form-label {\n      font-size: 0.9rem;\n      font-weight: 500;\n      margin-bottom: 0.5rem;\n      color: #495057;\n\n      strong {\n        color: #2C7EA0;\n      }\n    }\n\n    .form-control,\n    .form-select {\n      font-size: 0.85rem;\n      padding: 0.5rem;\n      border-radius: 4px;\n    }\n\n    .form-check {\n      margin-bottom: 0.5rem;\n\n      .form-check-label {\n        font-size: 0.85rem;\n        color: #495057;\n      }\n    }\n\n    .btn {\n      font-size: 0.85rem;\n      padding: 0.5rem 1rem;\n    }\n  }\n\n  .center-content {\n    flex: 1;\n    min-width: 0;\n    width: 100%;\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.2rem;\n      font-weight: 600;\n      margin-bottom: 1.5rem;\n    }\n\n    .card {\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  // Responsive adjustments for sidebar\n  @media (max-width: 768px) {\n    .main-content-flex {\n      flex-direction: column;\n      gap: 15px;\n    }\n\n    .sidebar.left {\n      width: 100%;\n      min-width: auto;\n      max-height: none;\n\n      &.closed {\n        width: 100%;\n        min-width: auto;\n      }\n    }\n\n    .center-content {\n      width: 100%;\n    }\n  }\n}\n",".p2p-container {\n  padding: 20px 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n\n  h1 {\n    color: #2C7EA0;\n    margin-bottom: 1rem;\n    font-weight: 600;\n  }\n\n  p {\n    color: #6c757d;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n  }\n\n  .card {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    margin-bottom: 1.5rem;\n\n    .card-header {\n      background-color: #f8f9fa;\n      border-bottom: 1px solid #dee2e6;\n      padding: 1rem 1.25rem;\n\n      h5 {\n        margin: 0;\n        color: #495057;\n        font-weight: 600;\n        font-size: 1.1rem;\n      }\n    }\n\n    .card-body {\n      padding: 1.5rem;\n    }\n  }\n\n  .form-label {\n    font-weight: 500;\n    color: #495057;\n    margin-bottom: 0.5rem;\n\n    strong {\n      color: #2C7EA0;\n    }\n  }\n\n  .form-control {\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:focus {\n      border-color: #2C7EA0;\n      box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n    }\n\n    &[readonly] {\n      background-color: #f8f9fa;\n      color: #6c757d;\n    }\n  }\n\n  .form-select {\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:focus {\n      border-color: #2C7EA0;\n      box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n    }\n  }\n\n  .form-check {\n    margin-bottom: 0.5rem;\n\n    .form-check-input {\n      &:checked {\n        background-color: #2C7EA0;\n        border-color: #2C7EA0;\n      }\n\n      &:focus {\n        border-color: #2C7EA0;\n        box-shadow: 0 0 0 0.2rem rgba(44, 126, 160, 0.25);\n      }\n    }\n\n    .form-check-label {\n      font-size: 0.9rem;\n      color: #495057;\n      cursor: pointer;\n    }\n  }\n\n  .btn {\n    font-weight: 500;\n    padding: 0.75rem 1.5rem;\n    border-radius: 6px;\n    transition: all 0.2s ease-in-out;\n    font-size: 0.9rem;\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    &.btn-primary {\n      background-color: #2C7EA0;\n      border-color: #2C7EA0;\n\n      &:hover:not(:disabled) {\n        background-color: #1e5a7a;\n        border-color: #1e5a7a;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-success {\n      background-color: #28a745;\n      border-color: #28a745;\n\n      &:hover:not(:disabled) {\n        background-color: #218838;\n        border-color: #218838;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-danger {\n      background-color: #dc3545;\n      border-color: #dc3545;\n\n      &:hover:not(:disabled) {\n        background-color: #c82333;\n        border-color: #c82333;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-secondary {\n      background-color: #6c757d;\n      border-color: #6c757d;\n\n      &:hover:not(:disabled) {\n        background-color: #5a6268;\n        border-color: #5a6268;\n        transform: translateY(-1px);\n      }\n    }\n\n    &.btn-info {\n      background-color: #17a2b8;\n      border-color: #17a2b8;\n\n      &:hover:not(:disabled) {\n        background-color: #138496;\n        border-color: #138496;\n        transform: translateY(-1px);\n      }\n    }\n  }\n\n  .alert {\n    border-radius: 6px;\n    border: none;\n    padding: 1rem 1.25rem;\n\n    &.alert-success {\n      background-color: #d4edda;\n      color: #155724;\n    }\n\n    &.alert-error {\n      background-color: #f8d7da;\n      color: #721c24;\n    }\n\n    &.alert-info {\n      background-color: #d1ecf1;\n      color: #0c5460;\n    }\n  }\n\n  .d-grid {\n    gap: 0.75rem;\n  }\n\n  .d-md-flex {\n    gap: 0.75rem;\n  }\n\n  // Table styling\n  .table {\n    background-color: #fff;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n    thead {\n      background-color: #f8f9fa;\n      \n      th {\n        border-bottom: 2px solid #dee2e6;\n        color: #495057;\n        font-weight: 600;\n        padding: 1rem 0.75rem;\n        font-size: 0.9rem;\n      }\n    }\n\n    tbody {\n      tr {\n        &:hover {\n          background-color: #f8f9fa;\n        }\n\n        td {\n          padding: 0.75rem;\n          border-top: 1px solid #dee2e6;\n          font-size: 0.9rem;\n          vertical-align: middle;\n        }\n      }\n    }\n  }\n\n  // Responsive adjustments\n  @media (max-width: 768px) {\n    padding: 15px;\n\n    .card-body {\n      padding: 1rem;\n    }\n\n    .btn {\n      padding: 0.6rem 1.2rem;\n      font-size: 0.85rem;\n    }\n\n    .form-control,\n    .form-select {\n      padding: 0.6rem;\n      font-size: 0.85rem;\n    }\n\n    .table {\n      font-size: 0.8rem;\n      \n      th, td {\n        padding: 0.5rem 0.25rem;\n      }\n    }\n  }\n\n  // Loading states\n  .loading {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n\n  // Generated link styling\n  .generated-link {\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n    font-size: 0.8rem;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    padding: 0.5rem;\n    word-break: break-all;\n  }\n\n  // Status message styling\n  .status-message {\n    font-weight: 500;\n    margin-bottom: 0;\n  }\n\n  // Section headers\n  h6 {\n    color: #495057;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 2px solid #e9ecef;\n  }\n\n  // Sidebar styles (identical to iConsult)\n  .main-content-flex {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n    width: 100%;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n  }\n\n  .sidebar {\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 20px;\n    position: relative;\n    transition: all 0.3s ease;\n\n    &.left {\n      width: 260px;\n      min-width: 260px;\n      max-height: 80vh;\n      overflow-y: auto;\n\n      &.closed {\n        width: 50px;\n        min-width: 50px;\n        padding: 10px;\n      }\n    }\n\n    .toggle-btn {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      z-index: 10;\n      padding: 4px 8px;\n      font-size: 12px;\n    }\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.1rem;\n      font-weight: 600;\n      margin-bottom: 1rem;\n      margin-top: 1.5rem;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n\n    .form-group {\n      margin-bottom: 1rem;\n    }\n\n    .form-label {\n      font-size: 0.9rem;\n      font-weight: 500;\n      margin-bottom: 0.5rem;\n      color: #495057;\n\n      strong {\n        color: #2C7EA0;\n      }\n    }\n\n    .form-control,\n    .form-select {\n      font-size: 0.85rem;\n      padding: 0.5rem;\n      border-radius: 4px;\n    }\n\n    .form-check {\n      margin-bottom: 0.5rem;\n\n      .form-check-label {\n        font-size: 0.85rem;\n        color: #495057;\n      }\n    }\n\n    .btn {\n      font-size: 0.85rem;\n      padding: 0.5rem 1rem;\n    }\n  }\n\n  .center-content {\n    flex: 1;\n    min-width: 0;\n    width: 100%;\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.2rem;\n      font-weight: 600;\n      margin-bottom: 1.5rem;\n    }\n\n    .card {\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  // Responsive adjustments for sidebar\n  @media (max-width: 768px) {\n    .main-content-flex {\n      flex-direction: column;\n      gap: 15px;\n    }\n\n    .sidebar.left {\n      width: 100%;\n      min-width: auto;\n      max-height: none;\n\n      &.closed {\n        width: 100%;\n        min-width: auto;\n      }\n    }\n\n    .center-content {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
